/**
 * Csv Schema of CompartilhamentoApp
 * @author Simpli CLI generator
 */
import {Helper, Schema, FieldSet} from 'simpli-web-sdk'
import {CompartilhamentoApp} from '@/model/resource/CompartilhamentoApp'

/* TODO: review generated schema */
export class CsvCompartilhamentoAppSchema extends Schema {
  readonly name = 'CsvCompartilhamentoApp'

  readonly fieldSet: FieldSet<CompartilhamentoApp> = {
    idCompartilhamentoAppPk: schema => schema.model.idCompartilhamentoAppPk,
    motorista: schema => schema.model.motorista?.$id ?? null,
    qtdCompartilhamento: schema => schema.model.qtdCompartilhamento,
  }
}
